import styled from 'styled-components';

export const Bar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(4)};
  margin-bottom: ${({ theme }) => theme.spacing(4)};
`;

export const Toolbar = styled.div`
  display: grid;
  grid-template-columns: minmax(220px, 1fr) auto auto auto auto;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing(3)};

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const SearchBox = styled.input`
  padding: 8px 12px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text.primary};
  font: inherit;
  font-size: 13px;
  transition: border-color 160ms ease;
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const FilterSelect = styled.select`
  padding: 8px 10px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text.primary};
  font: inherit;
  font-size: 13px;
  cursor: pointer;
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const ThSortable = styled.th<{ $active: boolean }>`
  cursor: pointer;
  user-select: none;
  color: ${({ theme, $active }) => ($active ? theme.colors.primary : 'inherit')};
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

// Сегментированный переключатель «В работе / Архив» для преддоговорного реестра.
export const Tabs = styled.div`
  display: inline-flex;
  gap: 2px;
  padding: 3px;
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.md};
  margin-bottom: ${({ theme }) => theme.spacing(4)};
`;

export const Tab = styled.button<{ $active: boolean }>`
  border: none;
  background: ${({ $active, theme }) => ($active ? theme.colors.background : 'transparent')};
  color: ${({ $active, theme }) =>
    $active ? theme.colors.text.primary : theme.colors.text.secondary};
  padding: 6px 16px;
  font: inherit;
  font-size: 13px;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  border-radius: ${({ theme }) => theme.radius.md};
  cursor: pointer;
  transition:
    background 160ms ease,
    color 160ms ease;
  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
  }
`;

// Кнопка «Вернуть» в строке архива — возврат преддоговора в рабочий реестр.
export const RestoreBtn = styled.button`
  border: 1px solid ${({ theme }) => theme.colors.border};
  background: transparent;
  color: ${({ theme }) => theme.colors.text.primary};
  border-radius: ${({ theme }) => theme.radius.md};
  padding: 4px 10px;
  font: inherit;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
  transition:
    background 160ms ease,
    border-color 160ms ease;
  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
  }
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

// Подпись «когда удалится» под бейджем причины в архиве.
export const ArchiveWhen = styled.div`
  font-size: 11px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-top: 2px;
`;

export const Pagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(3)};
  padding: ${({ theme }) => theme.spacing(3)} 0;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const PageButtons = styled.div`
  display: inline-flex;
  gap: 6px;
`;

export const PageBtn = styled.button<{ $active?: boolean }>`
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid
    ${({ theme, $active }) => ($active ? theme.colors.primary : theme.colors.border)};
  background: ${({ theme, $active }) => ($active ? theme.colors.primarySoft : 'transparent')};
  color: ${({ theme, $active }) => ($active ? theme.colors.primary : theme.colors.text.primary)};
  border-radius: ${({ theme }) => theme.radius.sm};
  font: inherit;
  font-size: 12px;
  cursor: pointer;
  transition:
    background 160ms ease,
    border-color 160ms ease;
  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.surface};
  }
  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`;

export const Empty = styled.td`
  text-align: center;
  padding: ${({ theme }) => theme.spacing(10)};
  color: ${({ theme }) => theme.colors.text.muted};
  font-size: 14px;
`;

export const UploadSizeHint = styled.div<{ $over: boolean }>`
  margin-top: ${({ theme }) => theme.spacing(2)};
  font-size: 12px;
  line-height: 1.5;
  color: ${({ theme, $over }) =>
    $over ? theme.colors.status.danger : theme.colors.text.muted};
`;

export const Note = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(4)};
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const CounterpartyCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const ContractNumber = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.muted};
`;

export const Divider = styled.div`
  margin: ${({ theme }) => theme.spacing(5)} 0;
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  position: relative;
  text-align: center;

  & > span {
    background: ${({ theme }) => theme.colors.backgroundElevated};
    padding: 0 ${({ theme }) => theme.spacing(3)};
    position: relative;
    top: -10px;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.text.muted};
  }
`;

// ─── Styled Components replacing inline styles ─────────────────────────

export const ContractsBarRight = styled.span`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(3)};
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.muted};
`;

export const ResetSearchButton = styled.button`
  background: transparent;
  border: none;
  color: inherit;
  cursor: pointer;
  text-decoration: underline;
`;

export const ExportCsvButton = styled.button`
  background: transparent;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 12px;
  color: inherit;
  cursor: pointer;
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const ContractRow = styled.tr`
  cursor: pointer;
`;

export const ContractFieldHint = styled.span`
  font-size: 11px;
  color: ${({ theme }) => theme.colors.text.muted};
  margin-top: 4px;
  display: block;
`;

export const UploadErrorBanner = styled.div`
  margin-top: 8px;
  margin-bottom: 12px;
  padding: 10px 14px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.status.danger}15;
  border: 1px solid ${({ theme }) => theme.colors.status.danger};
  color: ${({ theme }) => theme.colors.status.danger};
  font-size: 13px;
  line-height: 1.5;
`;
